import { render, staticRenderFns } from "./configuracion.vue?vue&type=template&id=2302a7bf&scoped=true&"
import script from "./configuracion.vue?vue&type=script&lang=ts&"
export * from "./configuracion.vue?vue&type=script&lang=ts&"
import style0 from "./configuracion.vue?vue&type=style&index=0&id=2302a7bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2302a7bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
